<script setup lang="ts">
import { useSmsStore } from '@/stores/sms'

defineProps<{
  canAccessSms: boolean
}>()

const emit = defineEmits<{
  home: []
  call: []
  sms: []
  history: []
}>()

const smsStore = useSmsStore()

const item = 'grow text-center text-[12px] flex flex-col justify-center cursor-pointer'
const itemContent = 'flex flex-col relative'
</script>

<template>
  <nav
    class="absolute bottom-0 left-0 right-0 z-[1000] will-change-transform [transform:translateZ(0)] flex h-[calc(60px+env(safe-area-inset-bottom,0px))] pb-[env(safe-area-inset-bottom,0px)] border-t border-[#eee] bg-white"
  >
    <div :class="item" @click="emit('home')">
      <div :class="itemContent">
        <i class="material-icons mb-[5px]">home</i>
        Home
      </div>
    </div>
    <div :class="item" @click="emit('call')">
      <div :class="itemContent">
        <i class="material-icons mb-[5px]">phone</i>
        Call
      </div>
    </div>
    <div v-if="canAccessSms" :class="item" @click="emit('sms')">
      <div :class="itemContent">
        <i class="material-icons mb-[5px]">sms</i>
        SMS
        <span
          v-if="smsStore.totalUnreadCount > 0"
          class="absolute -top-[2px] right-[14px] bg-[#ef5350] text-white text-[10px] font-semibold px-[5px] py-[2px] rounded-[10px] min-w-[16px] text-center"
          >{{ smsStore.totalUnreadCount }}</span
        >
      </div>
    </div>
    <div :class="item" @click="emit('history')">
      <div :class="itemContent">
        <i class="material-icons mb-[5px]">history</i>
        History
      </div>
    </div>
  </nav>
</template>
